<template lang="html">
	<div class="inner-modal">
		<div class="head-modal">
			<div class="head-modal-title">
				Diffuser un article
			</div>
			<div class="head-modal-emphase">
				Partager un article à vos clients
			</div>
		</div>
		<div class="body-modal">
			<form class="form-ui column default-form-ui">
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('lien')}">
						<label for="lien">Lien de l'article</label>
						<input v-validate="'required'" type="text" name="lien" v-model="news.link">
					</div>
					<div v-if="errors.has('lien')" class="error-message">{{ errors.first('lien') }}</div>
				</div>
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('titre')}">
						<label for="titre">Titre de l'article</label>
						<input v-validate="'required'" type="text" name="titre" v-model="news.title">
					</div>
					<div v-if="errors.has('titre')" class="error-message">{{ errors.first('titre') }}</div>
				</div>
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('description')}">
						<label for="description">Description</label>
						<input v-validate="'required'" type="text" name="description" v-model="news.body">
					</div>
					<div v-if="errors.has('description')" class="error-message">{{ errors.first('description') }}</div>
				</div>
				<div class="form-elem-container">
					<div class="ctn-input ctn-label" v-inputUI :class="{error: errors.has('lien de l\'image')}">
						<label for="lien de l\'image">Lien de l'image</label>
						<input v-validate="'required'" type="text" name="lien de l'image" v-model="news.link_image">
					</div>
					<div v-if="errors.has('lien de l\'image')" class="error-message">{{ errors.first('lien de l\'image') }}</div>
				</div>
				<div class="ctn-tags-selector">
					<div class="label">
						Sélectionnez les tags correspondants à l'article (3 max)
					</div>
					<div class="ctn-tags row">
						<div class="tag" v-for="tag in tags" :class="{ active: isSelectedTag(tag.id) }" v-bind:key="tag.id" @click="selectTag(tag)">
							{{ tag.wordpress_tag_name }}
						</div>
					</div>
				</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="share">Diffuser</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'share-news',
	data () {
		return {
			news: {
				title: null,
				link: null,
				link_image: null,
				body: null,
				selectedTags: []
			}
		}
	},
	methods: {
		close () {
			this.$emit('close')
		},
		isSelectedTag (id) {
			let isSelected = false
			this.news.selectedTags.forEach((tag) => {
				if (tag.id === id) {
					isSelected = true
				}
			})

			return isSelected
		},
		selectTag (newTag) {
			let isFound = false
			this.news.selectedTags.forEach((tag, key) => {
				if (tag.id === newTag.id) {
					isFound = true
					this.news.selectedTags.splice(key, 1)
				}
			})
			if (!isFound && this.news.selectedTags.length < 3) this.news.selectedTags.push(newTag)
		},
		share () {
			this.$validator.validate().then((validation) => {
				if (validation) {
					this.$store.dispatch('shareNews', this.news).then(() => {
						this.$notify({
							type: 'success',
							group: 'default',
							title: 'Vous avez partagé un article',
							text: ''
						})
						this.close()
					}).catch(() => {
						this.$notify({
							type: 'error',
							group: 'default',
							title: 'Une erreur est survenue',
							text: 'Veuillez vérifier les informations que vous avez envoyées'
						})
					})
				}
			})
		}
	},
	computed: {
		...mapGetters({
			tags: 'tags'
		})
	}
}
</script>

<style lang="scss" scoped>
.inner-modal {
	.body-modal {
		form {
			.form-elem-container {
				width: 100%;
				margin-top: 0;

				&:not(:first-child) {
					margin-top: 0.5rem;
				}
			}

			.ctn-tags-selector {
				.label {
					font-size: 0.9rem;
					font-weight: bold;
				}

				.ctn-tags {
					margin-top: 0.5rem;
					flex-wrap: wrap;
					.tag {
						cursor: pointer;
						width: calc(25% - 0.5rem);
						background-color: #F5F5F5;
						color: #af9376;
						padding: 0.5rem;
						border-radius: 10rem;
						text-align: center;
						font-size: 0.8rem;
						margin: 0.25rem;

						&.active {
							background-color: #ff4052;
							color: white;
						}
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// ShareNews.vue?25a0277e